<p-dialog
  [(visible)]="visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [showHeader]="false"
  [draggable]="false"
  [resizable]="false"
  (onShow)="splitMethodDropdown.focus()"
  styleClass="pos-dlg pos-dlg-md premium-dialog"
>
  <div class="premium-header">
    <div class="premium-header-content">
      <h3 class="premium-title">Split Bill</h3>
      <p class="premium-subtitle">Split by item or evenly between people</p>
    </div>
    <button type="button" class="premium-close-btn" (click)="hideSplitBillDialog()" aria-label="Close">
      <i class="pi pi-times"></i>
    </button>
  </div>

  <div class="premium-body split-body">
    <div class="split-field">
      <label class="split-label" for="splitMethod">Split method</label>
      <p-dropdown
        #splitMethodDropdown
        inputId="splitMethod"
        [options]="splitMethodOptions"
        [(ngModel)]="splitMethod"
        (onChange)="onSplitMethodChange()"
        optionLabel="label"
        optionValue="value"
        appendTo="body"
        styleClass="w-100"
      ></p-dropdown>
    </div>

    <ng-container *ngIf="splitMethod === 'item'">
      <p-table
        *ngIf="products?.length; else noItems"
        [value]="products"
        [paginator]="products.length > 10"
        [rows]="10"
        [rowsPerPageOptions]="[5, 10, 20]"
        styleClass="p-datatable-sm"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="split-col-select">Select</th>
            <th>Item name</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
          <tr>
            <td class="split-col-select">
              <p-checkbox
                [(ngModel)]="product.selected"
                [binary]="true"
                [name]="'selected_' + product.itemId"
              ></p-checkbox>
            </td>
            <td>{{ product.name }}</td>
          </tr>
        </ng-template>
      </p-table>
      <ng-template #noItems>
        <div class="split-empty">
          <i class="pi pi-shopping-cart" aria-hidden="true"></i>
          <p class="split-empty__title">No items to split</p>
          <p class="split-empty__hint">Add items to the cart, then split the bill.</p>
        </div>
      </ng-template>
    </ng-container>

    <div class="split-field" *ngIf="splitMethod === 'evenly'">
      <label class="split-label" for="splitPeople">Number of people</label>
      <p-inputNumber
        inputId="splitPeople"
        [(ngModel)]="numberOfPeople"
        [min]="1"
        [showButtons]="true"
        styleClass="w-100"
      ></p-inputNumber>
    </div>
  </div>

  <div class="premium-footer">
    <button type="button" class="premium-btn premium-btn-secondary" (click)="hideSplitBillDialog()">
      Close
    </button>
    <button type="button" class="premium-btn premium-btn-primary" (click)="applySplit()">
      <i class="pi pi-check"></i>
      Apply Split
    </button>
  </div>
</p-dialog>
